module.exports = __webpack_public_path__ + "assets/lessons/hr/lesson6/modals/lesson_6_4_c.pdf";